import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './OurApproach.css';
import Heading from '../../../utls/Heading';

const OurApproach = () => {
    return (
        <>
            <div className="my-lg-5  pt-lg-5">
                <div className="container">
                    <div className="row px-lg-5 px-md-3 ps-2 mt-md-4">
                        <div className="col-md-12">
                            <Heading className='headings headingFont mb-2'><span>How </span>Blueberry Travel Transforms Corporate Journey</Heading>
                            <p className='our-approach-p2 grotesk-headings'>
                            At Blueberry Travel, we don’t just talk about results—we believe in delivering them on time. Our case studies showcase the real-world impact of our customized travel solutions for businesses around the globe.
                            </p>
                            <p className='our-approach-p2 grotesk-headings'>As the trusted travel management provider to thousands of clients globally, across a vast business and industry segment, our knowledge and expertise in the travel industry delivers strategic results for every customer.
                            </p>
                            <p className='our-approach-p2 grotesk-headings'>Ready to experience the Blueberry difference? Explore our success stories and see how we can elevate your corporate travel!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OurApproach